import React, { useState, useEffect } from "react";
import Equipment from "../components/Equipment";
import Grid from "@mui/material/Grid";
import { LoopCircleLoading } from "react-loadingg";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function EquipmentList() {
  const [equipments, setEquipments] = useState([]);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [filteredEquipments, setFilteredEquipments] = useState([]);

  const [type, setType] = React.useState("");
  const [rarity, setRarity] = React.useState("");
  const [clas, setClas] = React.useState("");

  const handleChangeClas = (e) => {
    setRarity("All");
    setType("All");
    setClas(e.target.value);
    if (e.target.value === "All") {
      setFilteredEquipments(equipments);
    } else {
      const filtered = equipments.filter(
        (item) => item.occupation === e.target.value
      );

      setFilteredEquipments(filtered);
    }
  };

  const handleChangeType = (e) => {
    setClas("All");
    setRarity("All");
    setType(e.target.value);
    if (e.target.value === "All") {
      setFilteredEquipments(equipments);
    } else {
      const filtered = equipments.filter(
        (item) => item.type === e.target.value
      );

      setFilteredEquipments(filtered);
    }
  };

  const handleChangeRarity = (e) => {
    setType("All");
    setClas("All");
    setRarity(e.target.value);
    if (e.target.value === "All") {
      setFilteredEquipments(equipments);
    } else {
      const filtered = equipments.filter(
        (item) => item.rarity === e.target.value
      );

      setFilteredEquipments(filtered);
    }
  };

  useEffect(() => {
    fetch("https://revived-witch-api.herokuapp.com/api/equips")
      .then((res) => res.json())
      .then(
        (result) => {
          setEquipments(result.equipments);
          setFilteredEquipments(result.equipments);
          setIsLoaded(true);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  }, []);

  if (error) {
    return <>{error.message}</>;
  } else if (!isLoaded) {
    return (
      <div style={{ height: "100vh", weight: "50%" }}>
        <LoopCircleLoading />
      </div>
    );
  } else {
    return (
      <>
        <Grid container spacing={2} style={{ marginTop: "30px" }}>
          <Grid item xs={4} md={4} style={{ marginBottom: "30px" }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Class</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={clas}
                label="Class"
                onChange={(e) => handleChangeClas(e)}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Assassin">Assassin Weapon</MenuItem>
                <MenuItem value="Compeller">Compeller Weapon</MenuItem>
                <MenuItem value="Mage">Mage Weapon</MenuItem>
                <MenuItem value="Destroyer">Destroyer Weapon</MenuItem>
                <MenuItem value="Guardian">Guardian Weapon</MenuItem>
                <MenuItem value="Healer">Healer Weapon</MenuItem>
                <MenuItem value="Witch">Witch Weapon</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={4} md={4} style={{ marginBottom: "30px" }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={type}
                label="Type"
                onChange={(e) => handleChangeType(e)}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="armor">Armor</MenuItem>
                <MenuItem value="accesory">Accesory</MenuItem>
                <MenuItem value="arms">Weapon</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4} md={4} style={{ marginBottom: "30px" }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Rarity</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={rarity}
                label="Rarity"
                onChange={(e) => handleChangeRarity(e)}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Legend">Legendary</MenuItem>
                <MenuItem value="Gold">Gold</MenuItem>
                <MenuItem value="Purple">Purple</MenuItem>
                <MenuItem value="Blue">Blue</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          style={{
            marginBottom: 30,
            marginTop: 30,
            justify: "space-between",
            alignItems: "stretch",
          }}
        >
          {filteredEquipments.map((eq, index) => (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              sm={6}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Equipment key={eq._id} data={eq}/>
            </Grid>
          ))}
        </Grid>
      </>
    );
  }
}
